import React from 'react';
import { Alert, Box } from '@mui/material';

interface OpportunityStatusAlertProps {
  status: string;
  reviewMessage?: string;
}

const OpportunityStatusAlert: React.FC<OpportunityStatusAlertProps> = ({
  status,
  reviewMessage,
}) => {
  const renderAlert = () => {
    switch (status) {
      case 'DRAFT':
        return (
          <Alert severity="info" sx={{ mb: 2 }}>
            <strong>
              Tu oportunidad está en estado de borrador, publícala para mostrarla a los inversores
            </strong>
          </Alert>
        );
      case 'NEEDS_ATTENTION':
        return (
          <Alert severity="error" sx={{ mb: 2 }}>
            <strong>Tu oportunidad no cumple con los requisitos por los siguientes motivos:</strong>
            {reviewMessage && <Box sx={{ my: 1 }}>{reviewMessage}</Box>}
            <strong>Actualízala para solicitar una nueva revisión</strong>
          </Alert>
        );

      case 'IN_REVIEW':
        return (
          <Alert severity="warning" sx={{ mb: 2 }}>
            <strong>Tu oportunidad está en proceso de revisión. Te avisaremos pronto</strong>
          </Alert>
        );

      case 'PENDING':
        return (
          <Alert severity="success" sx={{ mb: 2 }}>
            <strong>Tu oportunidad está publicada</strong>
          </Alert>
        );

      case 'HIDDEN':
        return (
          <Alert severity="info" sx={{ mb: 2 }}>
            <strong>Esta oportunidad está oculta, no será visible para los inversores</strong>
          </Alert>
        );

      default:
        return null;
    }
  };

  return <>{renderAlert()}</>;
};

export default OpportunityStatusAlert;
